// extracted by mini-css-extract-plugin
export var addButton = "_io-0";
export var border = "_io-8";
export var check = "_io-h";
export var danger = "_io-6";
export var dropdownContainer = "_io-1";
export var editModalBody = "_io-j";
export var footerContainer = "_io-i";
export var fullWidth = "_io-a";
export var hide = "_io-9";
export var icon = "_io-3";
export var input = "_io-7";
export var inputFlex = "_io-b";
export var inputWrapper = "_io-c";
export var manualFocus = "_io-5";
export var optionButton = "_io-4";
export var pillWrapper = "_io-e";
export var pointer = "_io-2";
export var showOverflow = "_io-f";
export var tagsFlex = "_io-d";
export var xButton = "_io-g";